import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import PageHeader from "../../components/common/PageHeader";
import HsCodesPanel from "../../components/codes/HsCodesPanel";

// Add future code-type tabs here — e.g. { label: "Vessel Codes", component: VesselCodesPanel }
const CODE_TABS = [
    { label: "HS Codes", component: HsCodesPanel },
];

const AdminCodes = () => {
    const [tab, setTab] = useState(0);
    const ActivePanel = CODE_TABS[tab].component;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <PageHeader
                title="Codes"
                subtitle="Manage reference code lists used across shipments and customs declarations"
            />

            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    "& .MuiTab-root": {
                        fontSize: 13,
                        textTransform: "none",
                        fontWeight: 600,
                        minHeight: 44,
                    },
                }}
            >
                {CODE_TABS.map((t) => (
                    <Tab key={t.label} label={t.label} />
                ))}
            </Tabs>

            <ActivePanel />
        </Box>
    );
};

export default AdminCodes;